import React from 'react'
import styled, { css } from 'styled-components'
import FICIcon from '../../../common/components-v2/FICIcon/FICIcon'
import FICColors from '../../../common/styles/FICColors'

const InputTextIcon = styled(({ size, isDisabled, ...props }) => <FICIcon {...props} />)`
  position: absolute !important;
  color: ${FICColors.text.gray};
  line-height: ${props => props.size !== 'large' ? 30 : 40}px;
  font-size: 12px;
  ${props => props.isDisabled && css`
    color: ${FICColors.inputDisabledText};
    cursor: not-allowed;
  `}
`

export const LefIcon = styled(InputTextIcon)`
  left: 10px !important;
  right: auto;
  z-index: 1;
`

export const RightIcon = styled(({ isValid, ...props }) => <InputTextIcon {...props} />)`
  right: 10px !important;
  ${props => props.isValid === true && css`
    color:${FICColors.blue};
  `}
  ${props => props.isValid === false && css`
    color:${FICColors.red};
  `}
`



// WEBPACK FOOTER //
// ./src/common/components-v2/FICInputText/icons.js